import { LOGOUT_ACTION_TYPES } from '@/features/auth/logoutActionTypes'
import { hasTenantContextChanged, TENANT_SWITCH_FULFILLED } from '@/features/auth/tenantSwitchActionType'
import { IMPERSONATION_EXITED } from '@/features/auth/impersonationActionTypes'

const SESSION_CHANGE_TYPES = new Set([...LOGOUT_ACTION_TYPES, TENANT_SWITCH_FULFILLED, IMPERSONATION_EXITED])

/**
 * Redux middleware that empties the React Query cache on the same actions
 * that reset the Redux slices: logout (thunk fulfilled/rejected, or the
 * plain 401 `logout`), any active tenant change, and an ended impersonation. Runs after the reducers
 * so the new auth state is in place before any observer refetches.
 *
 * @param {import('@tanstack/react-query').QueryClient} queryClient
 */
export function clearQueryCacheOnSessionChange(queryClient) {
  return ({ getState }) => (next) => (action) => {
    const previousState = getState()
    const result = next(action)
    if (SESSION_CHANGE_TYPES.has(action?.type) || hasTenantContextChanged(previousState, getState())) {
      queryClient.clear()
    }
    return result
  }
}
